import { motion } from "framer-motion";
import { LOGO } from "@/data";
import { translations } from "@/i18n";

export default function LanguageModal({ onSelect }) {
  const m = translations.en.langModal;
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.4 }}
      className="fixed inset-0 z-[300] bg-[#050505] flex items-center justify-center px-6"
      data-testid="language-modal"
    >
      <motion.div
        initial={{ opacity: 0, y: 30, scale: 0.98 }}
        animate={{ opacity: 1, y: 0, scale: 1 }}
        transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
        className="text-center max-w-lg w-full"
      >
        <img src={LOGO} alt="Banman's Painting" className="h-24 w-24 rounded-full object-cover ring-1 ring-[#d4af37]/50 mx-auto gold-glow" />
        <h1 className="mt-8 font-serif-lux font-light text-4xl sm:text-5xl text-white">{m.title}</h1>
        <p className="mt-2 text-[#d4af37] uppercase tracking-[0.3em] text-xs">{m.subtitle}</p>

        <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 gap-5">
          <button
            onClick={() => onSelect("en")}
            data-testid="lang-en-btn"
            className="group border border-[#d4af37]/30 py-8 hover:bg-[#d4af37] transition-colors duration-300"
          >
            <span className="block font-serif-lux text-3xl text-white group-hover:text-black transition-colors duration-300">English</span>
            <span className="mt-1 block text-xs uppercase tracking-[0.25em] text-[#d4af37] group-hover:text-black/70 transition-colors duration-300">Continue</span>
          </button>
          <button
            onClick={() => onSelect("es")}
            data-testid="lang-es-btn"
            className="group border border-[#d4af37]/30 py-8 hover:bg-[#d4af37] transition-colors duration-300"
          >
            <span className="block font-serif-lux text-3xl text-white group-hover:text-black transition-colors duration-300">Español</span>
            <span className="mt-1 block text-xs uppercase tracking-[0.25em] text-[#d4af37] group-hover:text-black/70 transition-colors duration-300">Continuar</span>
          </button>
        </div>
      </motion.div>
    </motion.div>
  );
}
